import { useMemo } from "react";
import { useManualAuthoringStore } from "../../../../store/manualAuthoringStore";

type RefLinkProps = {
  targetId: string;
  label: string;
  className?: string;
};

export default function RefLink({ targetId, label, className }: RefLinkProps) {
  const manual = useManualAuthoringStore((s) => s.presentManual);
  const selectSection = useManualAuthoringStore((s) => s.selectSection);
  const selectSubSection = useManualAuthoringStore((s) => s.selectSubSection);
  const selectBlock = useManualAuthoringStore((s) => s.selectBlock);

  const resolvedLabel = useMemo(() => {
    let figureCounter = 0;
    let tableCounter = 0;

    for (const section of manual.sections) {
      for (const block of section.blocks || []) {
        if (block.layout === "figure") {
          figureCounter += 1;
          if (block.id === targetId) return `Figure ${figureCounter}`;
        }

        if (block.layout === "table") {
          tableCounter += 1;
          if (block.id === targetId) return `Table ${tableCounter}`;
        }
      }

      for (const sub of section.subSections || []) {
        for (const block of sub.blocks || []) {
          if (block.layout === "figure") {
            figureCounter += 1;
            if (block.id === targetId) return `Figure ${figureCounter}`;
          }

          if (block.layout === "table") {
            tableCounter += 1;
            if (block.id === targetId) return `Table ${tableCounter}`;
          }
        }
      }
    }

    return label;
  }, [label, manual.sections, targetId]);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    for (const section of manual.sections) {
      if (section.id === targetId) {
        selectSection(section.id);
        return;
      }

      if (section.blocks?.some((b) => b.id === targetId)) {
        selectSection(section.id);
        selectBlock(targetId);
        return;
      }

      for (const sub of section.subSections || []) {
        if (sub.id === targetId) {
          selectSubSection(section.id, sub.id);
          return;
        }

        if (sub.blocks?.some((b) => b.id === targetId)) {
          selectSubSection(section.id, sub.id);
          selectBlock(targetId);
          return;
        }
      }
    }
  };

  return (
    <button type="button" className={className} onClick={handleClick}>
      {resolvedLabel}
    </button>
  );
}
